/* eslint-disable no-unused-vars */
import { motion } from "motion/react";

export const MobileHeader = ({ mobileMenuOpen, setMobileMenuOpen }) => {
  return (
    <motion.button
      className="lg:hidden p-2 text-white flex-shrink-0 hover:bg-white/10 rounded-lg transition-all duration-200 scale-125"
      onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
      aria-label="Toggle mobile menu"
      whileHover={{ scale: 1.05 }}
      whileTap={{ scale: 0.95 }}
    >
      <div className="w-5 h-4 flex flex-col justify-between">
        <motion.div
          className="w-5 h-0.5 bg-current origin-center"
          animate={{
            rotate: mobileMenuOpen ? 45 : 0,
            y: mobileMenuOpen ? 8 : 0,
          }}
          transition={{ duration: 0.3, ease: 'easeInOut' }}
        />
        <motion.div
          className="w-5 h-0.5 bg-current"
          animate={{
            opacity: mobileMenuOpen ? 0 : 1,
            x: mobileMenuOpen ? 10 : 0,
          }}
          transition={{ duration: 0.2, ease: 'easeInOut' }}
        />
        <motion.div
          className="w-5 h-0.5 bg-current origin-center"
          animate={{
            rotate: mobileMenuOpen ? -45 : 0,
            y: mobileMenuOpen ? -8 : 0,
          }}
          transition={{ duration: 0.3, ease: 'easeInOut' }}
        />
      </div>
    </motion.button>
  );
};